import { CheckCircle2, Circle, Upload } from "lucide-react";
import type { FilterOperator } from "@/components/ui";
import type { SortState } from "@/components/ui";
import type { LucideIcon } from "lucide-react";

// ─── labelKey-based types (resolved at runtime via t()) ─────────────────────

export interface FilterValueKey {
  id: string;
  labelKey: string;
  icon?: LucideIcon;
  color?: string;
}

export interface FilterCategoryKey {
  id: string;
  labelKey: string;
  icon: LucideIcon;
  allowedOperators: FilterOperator[];
  values: FilterValueKey[];
}

export interface FilterCategoryGroupKey {
  labelKey: string;
  categories: FilterCategoryKey[];
}

export interface SortOptionKey {
  id: string;
  labelKey: string;
}

// ─── Filter data (labelKey, not label) ──────────────────────────────────────

export const CHECKLIST_FILTER_CATEGORIES: FilterCategoryGroupKey[] = [
  {
    labelKey: "checklist.filters.properties",
    categories: [
      {
        id: "status",
        labelKey: "checklist.filters.status",
        icon: Circle,
        allowedOperators: ["is", "is_not", "is_either_of"],
        values: [
          {
            id: "approved",
            labelKey: "checklist.status.approved",
            icon: CheckCircle2,
            color: "#4CAF50",
          },
          {
            id: "uploaded",
            labelKey: "checklist.status.uploaded",
            icon: Upload,
            color: "#E8862A",
          },
          {
            id: "missing",
            labelKey: "checklist.status.missing",
            icon: Circle,
            color: "#9B9B9B",
          },
        ],
      },
      {
        id: "required",
        labelKey: "checklist.filters.required",
        icon: Circle,
        allowedOperators: ["is"],
        values: [
          { id: "yes", labelKey: "checklist.filters.required" },
          { id: "no", labelKey: "checklist.filters.optional" },
        ],
      },
    ],
  },
];

// ─── Sort data (labelKey, not label) ────────────────────────────────────────

export const CHECKLIST_SORT_OPTIONS: SortOptionKey[] = [
  { id: "name", labelKey: "checklist.filters.sortName" },
  { id: "status", labelKey: "checklist.filters.sortStatus" },
  { id: "dueDate", labelKey: "checklist.filters.sortDueDate" },
  { id: "required", labelKey: "checklist.filters.sortRequired" },
];

export const DEFAULT_CHECKLIST_SORT: SortState = {
  field: "name",
  direction: "asc",
};
